'use client';
var classes = {"root":"m_8a5d1357"};

export { classes as default };
//# sourceMappingURL=Title.module.css.mjs.map
